import moment from "moment";
import { ShoppingList } from "./shopping-list";

export interface IOrder {
  id: number;
  submittedAt: moment.Moment;
  comment: string;
  shoppingList: ShoppingList;
}

export class Order {
  public id!: number;
  public submittedAt!: moment.Moment;
  public comment!: string;
  public shoppingList?: ShoppingList;

  constructor(order?: IOrder) {
    if (order) {
      Object.assign(this, order);
      if (order.submittedAt) {
        this.submittedAt = moment(order.submittedAt);
      }
    }
  }
}
